module.exports = __webpack_public_path__ + "static/diggerhamper-1c41f669ad7b9be91d88d502952c874a.jpeg";